import React from 'react';
import { Alert } from 'antd';

const ClosingPackageTaskModalEventDateHint: React.FC = () => (
  <Alert
    type="info"
    showIcon
    message="Дата события"
    description="Дата события сохраняется как бизнес-событие (Event Date) и не совпадает автоматически с датой закрытия задачи."
  />
);

export default ClosingPackageTaskModalEventDateHint;
